import groq from 'groq';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const blockSalesforceFormsFields = groq`
  salesforceForm->{
  ...,
  fieldsTexts {
    ...,
    noteText[] {
      ${portableTextWithReferences},
    },
  },
  platformOptions {
    ...,
    platformOptionsValidationMessage[] {
      ${portableTextWithReferences},
    },
  },
  blockerInputTexts {
    ...,
    blockerValidationMessage[] {
      ${portableTextWithReferences},
    },
  }
}`;
